import React, { useEffect } from 'react';
import AppRouter from './AppRouter/AppRouter';
import config from '../config';
import * as gtag from '../gtag';
import useScript from './useScript';
import './App.css';
import NotifyError from './Notify/NotifyError';

const App = (): JSX.Element => {
  useScript(config.GOOGLE_ANALYTICS_URL || '');

  useEffect(() => {
    gtag.pageview(window.location.pathname);

    document.documentElement.scrollTop = 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  return (
    <div className="App">
      <NotifyError />
      <AppRouter />
    </div>
  );
};

export default App;
